import { useNavigate } from "react-router";
import { useAuth } from "./useAuth";
import { useCallback } from "react";

export const useLogout = () => {
  const user = useAuth();
  let navigate = useNavigate();

  const handleLogout = useCallback(() => {
    localStorage.removeItem("user");
    user.refetch();
    return navigate("/login");
  }, [navigate, user]);

  return handleLogout;
};
